import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../App";
import useInvoke from "../Tools/Invoker";
import DynamicGrid from "../Tools/DynamicGrid";
import LoginRedirect from "../Page/LoginRedirect";
import CheckToken from "../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import UpdateUser from "./UpdateUser";


const ChangePassword = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { localStorage.clear(); setUser({}); navigate("/Login") } });

    const handleFormSubmit = (e) => {
        let newPassword = document.getElementById("newpassword").value;
        let confirmPassword = document.getElementById("confirm").value;
        if (newPassword == confirmPassword) {

            let isAdmin = false;
            user["role"] == "Admin" ? isAdmin = 1 : isAdmin = 0;

            //send password change request
            UpdateUser(
                user["id"],
                user["id"],
                newPassword,
                user["token"],
                user["firstname"],
                user["lastname"],
                user["email"],
                isAdmin,
                0

            ).then((response) => {
                if (response) {
                    toast.success('Password changed successfully.')
                    localStorage.clear();
                    setUser({});
                    navigate("/");
                    //window.location.reload();
                }
                else {
                    toast.error("Update Failed.");
                }
            });

        }
        else {
            toast.error('Passwords do not match.');
        }

    };

    return (
        <div className="ChangePassword">
            <div className="container body-content" style={{ marginTop: "25px" }}>
                <div className="container" style={{ marginTop: "25px", display: "flex", flexDirection: "column", alignItems: "center" }}>

                    <form id="changePasswordForm" noValidate="novalidate" autoComplete="off">
                        <h2>Change Password</h2>
                        <div className="form-group">
                            <label htmlFor="newpassword">New Password</label>
                            <input className="form-control" style={{ width: "360px" }} id="newpassword" name="newpassword" placeholder="New Password" type="password" autoComplete="off" />

                            <label htmlFor="confirm">Confirm Password</label>
                            <input className="form-control" style={{ width: "360px" }} id="confirm" name="confirm" placeholder="Re-Enter New Password" type="password" autoComplete="off" />

                        </div>
                    </form>

                    <button onClick={handleFormSubmit} className="btn btn-primary" style={{ marginRight: "4px", paddingLeft: "32px", paddingRight: "32px" }}>Change Password</button>
                </div>
            </div>
        </div>
    );
}

export default ChangePassword;